import styled from "styled-components";

export const AdjustmentModalInnerBoxes = styled.div`
  border-radius: 4px 4px 0 0;
  border: solid 1px #87cdf1;
  overflow: hidden;
  background: linear-gradient(180deg, #ffffff 0%, #e9f8ff 100%);
  p {
    text-align: center;
    font-size: 18px;
  }
  .exchange-modal-header {
    display: flex;
    justify-content: space-between;
    padding: 10px;
    h1 {
      font-size: 20px;
    }
    img {
      height: 28px;
      width: 28px;
      cursor: pointer;
    }
  }
`;


export const AdjustRefundSection = styled.div`
padding: 20px 0;
.claim-info-section {
  border-radius: 5px;
}
h6 {
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 19px;
  padding-top: 7px
}
.claim-info {
  display: flex;
  flex-direction: column;
  padding: 5px 14px 2px 0px;
  p{
    margin: 2px 0;
  }
  hr{
    margin : 5px 0px 5px 0px;
  }
  div {
    display: flex;
    p:first-child {
      width: 210px;
    }
  }
}
span {
  font-weight: 400;
  font-size: 16px;
  line-height: 16px;
}
.app-input-text{
  margin-bottom: 10px !important;
}
.app-input-text.number-format-input-styles, .app-input-text.text-input-styles{
  flex-grow: 1;
  margin-left: 1.5rem;
}
.w-min-150{
  width: 150px;
}
.disable-resize {
  resize: none;
}
.charge-reason-textarea{
  max-width: 252px;
}
.app-input-text textarea.charge-reason{
  height: auto;
  flex-grow: 1;
  text-wrap: nowrap;
  overflow-x: hidden;
}
@media screen and (max-width: 465px){
  .charge-reason-textarea{
    max-width: 192px;
  }
}
`;
export const SubmitButtonWrapper = styled.div`
.submit-button-wrapper {
  text-align: -webkit-center;
  padding: 10px;
}
`;

export const ConfirmationModalWrapper = styled.div `
  .modal-header{
    border-radius: 4px 4px 0 0;
    border: solid 1px #87cdf1;
    overflow: hidden;
    background: linear-gradient(180deg, #ffffff 0%, #e9f8ff 100%);
    padding: 10px;
    h1 {
      font-size: 20px;
    }
  }
  .modal-footer{
    background: #f2f2f2;
    padding: 6px;
  }
  .modal-title{
    font-size: 1rem;
  }
  button {
    border: none;
    margin-right: 10px;
    padding: 5px 15px 5px 15px;
  }
  .no-button {
    background: #b8b8b8;
    border-radius: 5px;
  }
  .yes-button {
    background: linear-gradient(180deg, #55c416 0%, #367910 100%);
    border-radius: 5px;
  }
`;